import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/market-place/services/product.service';
import { DataProduct } from '../../login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-productos-marketplace',
  templateUrl: './productos-marketplace.component.html',
  styleUrls: ['./productos-marketplace.component.scss'],
})
export class ProductosMarketplaceComponent implements OnInit, OnDestroy {
  @Input() productsHome: DataProduct[];
  public urlMarketplace = `/market-place/products`;
  private productObs: Subscription = new Subscription();

  constructor(
    private router: Router,
    private productsService: ProductService,
    private storageService: StorageService
  ) {}

  ngOnInit() {}

  goProduct(userId, idProduct: number) {
    this.productObs = this.productsService.getProduct(idProduct).subscribe((res: any) => {
      const dataProduct: DataProduct = res.data.data;
      this.storageService.set('media', dataProduct.media);
      this.storageService.set('family', res.data.family);
      this.storageService.set('relation', res.data.relation);
      this.router.navigate([this.urlMarketplace, userId, idProduct], {
        queryParams: dataProduct,
      });
    });
  }

  ngOnDestroy(): void {
    this.productObs.unsubscribe();
  }
}
